'use strict';

import { useEffect } from 'react';
import { ENABLE_PIPELINE_STATUS, USE_PIPELINE_STATUS_API_MOCKS } from '@/config/env.config';
import { useCanAccessProjectPipelineStatus } from '@/features/pipelineStatus/usePipelineStatus';
import {
	joinProjectPipelineTrackerGroup,
	leaveProjectPipelineTrackerGroup,
} from '@/services/projectsHub.service';

/**
 * Subscribe to ProjectsHub pipeline-status group for `projectId` (legacy group prefix `pipeline-tracker:`; SignalR hints → RTK invalidation elsewhere).
 * When the PipelineStatus feature flag is off, or `USE_PIPELINE_STATUS_API_MOCKS` is on (default), this is a **no-op**.
 * @param {string | undefined} projectId
 */
export function usePipelineStatusHub(projectId) {
	const canAccessProjectPipelineStatus = useCanAccessProjectPipelineStatus();

	useEffect(() => {
		if (!ENABLE_PIPELINE_STATUS) return undefined;
		if (!canAccessProjectPipelineStatus) return undefined;
		if (USE_PIPELINE_STATUS_API_MOCKS) return undefined;
		if (!projectId) return undefined;
		void joinProjectPipelineTrackerGroup(projectId);
		return () => {
			void leaveProjectPipelineTrackerGroup(projectId);
		};
	}, [projectId, canAccessProjectPipelineStatus]);
}
